module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_5-13ec93fa707d1172e6e38833fc7a5785.png";